<template>
  <div
    class="content content-login-block w-100 h-100 d-flex justify-content-center align-items-center flex-column position-relative"
  >
    <div class="logo-top">
      <router-link to="/">
        <img :src="logo" class="logo-top my-5" />
      </router-link>
    </div>
    <div class="row content-body login-body align-items-center">
      <div class="col-lg-12">
        <div class="row gap-3 flex-nowrap cards-login">
          <div class="col-lg-4 col-5 px-0">
            <div class="card-login text-center">
              <img :src="checked" class="checked-card" />

              <router-link to="/login-veterinaire" class="d-block icon-wrapper selected">
                <img :src="icon1" />
              </router-link>
            </div>
          </div>
          <div class="col-lg-4 col-5 px-0">
            <div class="card-login text-center">
              <router-link to="/login-proprietaire" class="d-block icon-wrapper">
                <img :src="icon2" />
              </router-link>
            </div>
          </div>
        </div>

        <p class="title mt-3 mb-3" v-html="$sanitize.sanitizeI18nContent($t('veterinaire_connect.description'))"></p>

        <div class="row justify-content-center">
          <div class="col-lg-10 my-2">
            <div class="mx-auto form-login d-flex flex-column">
              <input
                type="text"
                v-model="email"
                class="input-text mb-4"
                :class="{ error: errorEmail }"
                :placeholder="$t('veterinaire_connect.placeholders.email')"
              />
              <span v-if="errorEmail" class="error-message mb-4">{{ errorEmail }}</span>
              <input
                type="password"
                v-model="password"
                class="input-text mb-4"
                :class="{ error: errorPassword }"
                :placeholder="$t('veterinaire_connect.placeholders.password')"
              />
              <span v-if="errorPassword" class="error-message mb-4">{{ errorPassword }}</span>
              <button class="btn text-white btn-login w-100 mb-4" @click.prevent="handleLogin" :disabled="isLoading">
                <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{ isLoading ? $t("veterinaire_connect.buttons.logging_in") : $t("veterinaire_connect.buttons.login") }}
              </button>
              <span v-if="errorMessage" class="error-message mb-4">{{ errorMessage }}</span>
              <div class="row">
                <label class="checkbox-container col-lg-6 col-md-6 col-6 col-sm-6">
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                  <label class="mx-2">{{ $t("veterinaire_connect.labels.remember_me") }}</label>
                </label>
                <router-link to="/forget-password-veterinaire" class="link-forget col-lg-6 col-6 col-md-6 col-sm-6">{{
                  $t("veterinaire_connect.links.forgot_password")
                }}</router-link>
              </div>
              <button class="btn btn-register w-100 mt-4" @click.prevent="FirstLogin">
                {{ $t("veterinaire_connect.buttons.first_login") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { login } from "@/api/auth";
  import icon1 from "@/assets/images/doctor.svg";
  import icon2 from "@/assets/images/animaux.svg";
  import checked from "@/assets/images/check-box.png";
  import logo from "@/assets/images/2_LOGO - COULEURS-bg-b.png";
  import { useAuthStore } from "@/stores/authStore";
  import { useRegisterStore } from "@/stores/register";
  import AuthService from "@/services/authService";
  import { extractUserFromToken, validateUserRole } from "@/utils/jwtHelpers";

  export default {
    name: "VeterinaireLogin",
    data() {
      return {
        icon1,
        icon2,
        logo,
        checked,
        email: "",
        password: "",
        type: "veterinaires",
        errorMessage: null,
        errorEmail: "",
        errorPassword: "",
        isLoading: false,
        canStore: true,
      };
    },
    mounted() {
      // Utilisation d'AuthService pour vérifier l'authentification
      if (AuthService.isAuthenticated()) {
        this.$router.push("/dashboard");
      }
    },
    methods: {
      FirstLogin() {
        this.$router.push("/forget-password-veterinaire");
      },
      async handleLogin() {
        this.errorMessage = "";
        this.errorEmail = "";
        this.errorPassword = "";
        this.canStore = true;
        this.isLoading = true;

        // Validation des champs
        this.CheckValidate();

        if (!this.canStore) {
          this.isLoading = false;
          return;
        }

        try {
          const res = await login(this.email, this.password, this.type);

          const authStore = useAuthStore();
          const registerStore = useRegisterStore();

          const token = res.data.token;
          const jwtUserData = extractUserFromToken(token);
          if (!jwtUserData) {
            console.error("Erreur : Token JWT invalide ou corrompu");
            throw new Error("Authentification échouée - Token invalide");
          }
          if (!validateUserRole(token, "veterinaire")) {
            console.warn("Accès refusé : utilisateur sans droits vétérinaire");
            this.errorMessage = this.$t("veterinaire_connect.errors.access_denied");
            this.isLoading = false;
            return;
          }

          const user = {
            id: jwtUserData.id,
            email: jwtUserData.email,
            fullName: jwtUserData.fullName,
            firstName: jwtUserData.firstName,
            lastName: jwtUserData.lastName,
            gender: jwtUserData.gender,
            role: "veterinaire",
          };

          authStore.setToken(token);
          authStore.setUser(user);
          registerStore.setUser(user);
          const data_veterinaire = {
            lastName: jwtUserData.lastName,
            firstName: jwtUserData.firstName,
            fullName: jwtUserData.fullName,
            email: jwtUserData.email,
            phone: null, // Sera chargé plus tard si nécessaire
            postcode: null,
            street: null,
            city: null,
            customer_infos: {
              id: jwtUserData.id,
              email: jwtUserData.email,
              fullName: jwtUserData.fullName,
              firstName: jwtUserData.firstName,
              lastName: jwtUserData.lastName,
              gender: jwtUserData.gender,
            },
            address_infos: null, // Sera chargé plus tard si nécessaire
          };
          registerStore.setInfoveterinaire(data_veterinaire);

          this.isLoading = false;
          this.$router.push("/dashboard");
        } catch (error) {
          console.error("Erreur lors du login:", error);
          this.isLoading = false;
          this.errorMessage = error.response
            ? error.response.data.message === "Bad Request"
              ? this.$t("veterinaire_connect.errors.incorrect_credentials")
              : error.response.data.message
            : this.$t("veterinaire_connect.errors.login_failed");
        }
      },
      CheckValidate() {
        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (this.email === "") {
          this.errorEmail = this.$t("veterinaire_connect.errors.email_required");
          this.canStore = false;
        } else {
          if (!regexEmail.test(this.email)) {
            this.errorEmail = this.$t("veterinaire_connect.errors.email_invalid");
            this.canStore = false;
          }
        }

        if (this.password === "") {
          this.errorPassword = this.$t("veterinaire_connect.errors.password_required");
          this.canStore = false;
        }
      },
    },
  };
</script>

<style scoped>
  @import "@/assets/css/components/VeterinaireConnect.css";
   .login-body .icon-wrapper.selected {
    background: #c9cfde 0% 0% no-repeat padding-box;
  }
</style>
